import Container from 'react-bootstrap/Container';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';

const GalleryScreen = () => {
  const [show, setShow] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const imagesL = [
    '1.jpg',
    '2.jpg',
    '3.jpg',
    '4.jpg',
    '5.jpg',
    '6.jpg',
    '7.jpg',
    '8.jpg',
    '9.jpg',
    '10.jpg',
  ];
  const imagesP = [
    'p-1.jpg',
    'p-2.jpg',
    'p-3.jpg',
    'p-4.jpg',
    'p-5.jpg',
    'p-6.jpg',
    'p-7.jpg',
    'p-8.jpg',
    'p-9.jpg',
    'p-10.jpg',
  ];
  const handleOnClick =(img) => {
    setModalImage(img);
    handleShow();
  };
  return (
    <Container className="small-container">
      <Helmet>
        <title>Gallery</title>
      </Helmet>
      <h1 className="my-3">Gallery</h1>
      <p>
        Photos of the previous outreach where we donated groceries and toys in 2020(Laguna) and 2021(Bulacan).
      </p>
      <Modal show={show} onHide={handleClose}>
        <img src={modalImage} />
      </Modal>
      <div class="row">
        <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
          {[1,2,3].map((img, index) => {
            return (
            <>
              <img
                src={`images/outreach-1/${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/${img}.jpg`)}
              />
              <img
                src={`images/outreach-1/p-${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/p-${img}.jpg`)}
                />
            </>);
          })}
        </div>

        <div class="col-lg-4 mb-4 mb-lg-0">
        {[4,5,6].map((img, index) => {
            return (
            <>
              <img
                src={`images/outreach-1/p-${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/p-${img}.jpg`)}
              />
              <img
                src={`images/outreach-1/${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/${img}.jpg`)}
                />
            </>);
          })}
        </div>

        <div class="col-lg-4 mb-4 mb-lg-0">
        {[7,8,9].map((img, index) => {
            return (
            <>
              <img
                src={`images/outreach-1/${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/${img}.jpg`)}
              />
              <img
                src={`images/outreach-1/p-${img}.jpg`}
                class="w-100 shadow-1-strong rounded mb-4"
                onClick={() => handleOnClick(`images/outreach-1/p-${img}.jpg`)}
                />
            </>);
          })}
        </div>
      </div>
    </Container>
  );
}

export default GalleryScreen;
